import { HttpClient, HttpHeaders } from '@angular/common/http';
import { ClientSideRowModelModule } from '@ag-grid-community/client-side-row-model';
import { RowGroupingModule } from '@ag-grid-enterprise/row-grouping';
import { customLines, productLines } from '../details/offer';
import { Observable } from 'rxjs';
import * as api from '../../shared/api/apihandler';

export class ProductFunctions {
  constructor(private http: HttpClient) { }

  addProductLineToOffer(offerId: string, c: JoinedProduct) {
    const headers: HttpHeaders = new HttpHeaders({ 'Authorization': localStorage.getItem('bearer') });
    return this.http.post(api.jubloApi + 'api/Website/Offer/AddProductToOfferV2/' + offerId, {
      id: c.id,
      productNumber: c.number,
      description: c.description,
      wholeSaler: !!c.wholesaler ? c.wholesaler.toString() : null,
      manufacturer: c.manufacturer,
      quantity: c.amount,
      costPrice: c.cost,
      listPrice: c.sale,
      image: c.image,
      profit: c.profit,
      discount: c.discount,
      sortOrder: c.sortOrder,
      companyProduct: c.companyProduct,
      packageId: c.unitId,
      path: c.path,
      accountId: c.accountId
    }, { headers })
  }

  deleteProductLineFromOffer(offerId: string, p: string) {
    const headers: HttpHeaders = new HttpHeaders({ 'Authorization': localStorage.getItem('bearer') });
    return this.http.post(api.jubloApi + 'api/Website/Offer/Delete/productLineV2/' + offerId, { "id": p }, { headers }).subscribe(() => {
      // console.log('product id ' + p + ' deleted')
    }, (err) => { console.log(err) })
  }

  deleteProductFromOffer(offerId: string, p: string) {
    const headers: HttpHeaders = new HttpHeaders({ 'Authorization': localStorage.getItem('bearer') });
    return this.http.post(api.jubloApi + 'api/Website/Offer/Delete/productLineV2/' + offerId, { "id": p }, { headers })
  }

  addCustomLineToOffer(offerId: string, c: JoinedProduct) {
    const headers: HttpHeaders = new HttpHeaders({ 'Authorization': localStorage.getItem('bearer') });
    return this.http.post(api.jubloApi + 'api/Website/Offer/AddCustomlineToOffer/' + offerId, {
      id: null,
      name: c.description,
      costPrice: c.cost,
      salesPrice: c.sale,
      quantity: c.amount,
      profit: ((c.sale - c.cost) / c.cost) * 100,
      discount: 0,
      priceGroupId: c.priceGroupId,
      sortOrder: c.sortOrder,
      packageId: c.unitId,
      path: c.path
    }, { headers })
  }

  deleteCustomLineFromOffer(offerId: string, id: string) {
    const headers: HttpHeaders = new HttpHeaders({ 'Authorization': localStorage.getItem('bearer') });
    return this.http.delete(api.jubloApi + 'api/Website/Offer/DeleteCustomLineById/' + offerId + '/' + id, { headers }).subscribe(() => { }, (err) => { console.log(err) })
  }

  deleteCustomFromOffer(offerId: string, id:string){
    const headers: HttpHeaders = new HttpHeaders({ 'Authorization': localStorage.getItem('bearer') });
    return this.http.delete(api.jubloApi + 'api/Website/Offer/DeleteCustomLineById/' + offerId + '/' + id, { headers })
  }

  deleteCommentLineFromOffer(offerId: string, id: string) {
    const headers: HttpHeaders = new HttpHeaders({ 'Authorization': localStorage.getItem('bearer') });
    return this.http.post(api.jubloApi + 'api/Website/Offer/DeleteSingleCommentLine/' + offerId + '/' + id, {}, { headers }).subscribe(
      () => { },
      (err) => { console.log('error') }
    )
  }

  deleteCommentFromOffer(offerId: string, id: string) {
    const headers: HttpHeaders = new HttpHeaders({ 'Authorization': localStorage.getItem('bearer') });
    return this.http.post(api.jubloApi + 'api/Website/Offer/DeleteSingleCommentLine/' + offerId + '/' + id, {}, { headers })
  }

  addCommentLine(offerId, comment, path, sortOrder) {
    let nullcheckPath = !!path && path != 'null' ? path : null
    const headers = new HttpHeaders({ 'Authorization': localStorage.getItem('bearer') });
    return this.http.post(api.jubloApi + 'api/Website/Offer/AddSingleCommentLine/' + offerId, {
      id: null,
      comment: comment,
      sortOrder: sortOrder,
      path: nullcheckPath
    }, { headers })
  }

  async commentLine(text) {
    let a = new JoinedProduct();
    a.type = 'comment';
    a.description = await this.htmlToText(text);
    a.sortOrder = -1;
    return a;
  }

  async groupLine(name: string) {
    let a = new JoinedProduct();
    a.type = 'group';
    a.description = name;
    a.sortOrder = 0;
    return a
  }

  async htmlToText(text): Promise<string> {
    var tempDiv = document.createElement('div');
    tempDiv.innerHTML = text;
    return tempDiv.innerText
  }

  diffCheck(a: number, b: number, diff = 1) {
    return Math.abs(a - b) < diff ? false : true;
  }

  async convertLinesToJoinedLines(o): Promise<JoinedProduct[]> {
    let cus, pro, com, sub = [];
    cus = o.customLines.map(c => {
      return {
        id: c.id,
        description: c.name.replace('[ProductGroupId]', '').trim(),
        number: '',
        cost: c.costPrice,
        sale: c.salesPrice,
        profit: c.profit,
        discount: c.discount,
        amount: c.quantity,
        image: '',
        sortOrder: c.sortOrder,
        totalCost: c.totalCostPrice,
        totalSale: c.totalSalesPrice,
        wholesaler: '',
        type: c.name.includes('ProductGroupId') ? 'group' : 'custom',
        companyProduct: false,
        manufacturer: '',
        priceGroupId: c.priceGroupId,
        unitId: c.packageId,
        path: c.name.includes('ProductGroupId') ? this.checkGroupPath(c) : c.path,
        accountId: null,
        hideOnPdf: c.showOnPdf
      }
    });
    pro = o.productLines.map(p => {
      return {
        id: p.id,
        description: p.description,
        number: p.productNumber,
        cost: p.costPrice,
        sale: p.listPrice,
        profit: p.profit,
        discount: p.discount,
        amount: p.quantity,
        image: p.image,
        sortOrder: p.sortOrder,
        totalCost: p.totalCostPrice,
        totalSale: p.listPrice * p.quantity,
        wholesaler: p.wholeSaler != null ? p.wholeSaler.toString() : null,
        type: 'product',
        companyProduct: p.companyProduct,
        manufacturer: p.manufacturer,
        priceGroupId: null,
        unitId: p.packageId,
        path: p.path ? p.path.replace('null/', '') : p.path,
        accountId: p.accountId,
        hideOnPdf: p.showOnPdf
      }
    })
    com = !!o.commentLines ? o.commentLines.map(c => {
      return {
        id: c.id,
        description: c.comment,
        number: null,
        cost: null,
        sale: null,
        profit: null,
        discount: null,
        amount: null,
        image: null,
        sortOrder: c.sortOrder,
        totalCost: null,
        totalSale: null,
        wholesaler: null,
        type: 'comment',
        companyProduct: null,
        manufacturer: null,
        priceGroupId: null,
        unitId: null,
        path: c.path ? c.path.replace('null/', '') : c.path,
        accountId: null,
        hideOnPdf: c.showOnPdf
      }
    }) : [];
    sub = !!o.subContractorLines ? o.subContractorLines.map(s => {
      return {
        id: s.id,
        description: s.name,
        number: '',
        cost: s.costPrice,
        sale: s.salesPrice,
        profit: s.profit,
        discount: s.discount,
        amount: s.quantity,
        image: '',
        sortOrder: s.sortOrder,
        totalCost: s.totalCostPrice,
        totalSale: s.totalSalesPrice,
        wholesaler: '',
        type: 'subcontractor',
        companyProduct: false,
        manufacturer: '',
        priceGroupId: s.priceGroupId,
        unitId: null,
        path: s.path ? s.path.replace('null/', '') : s.path,
        subcontractor: s.subContractor,
        accountId: null,
        hideOnPdf: s.showOnPdf
      }
    }) : [];
    return cus.concat(pro).concat(com).concat(sub).sort((a, b) => a.sortOrder < b.sortOrder ? -1 : 1)
  }

  checkGroupPath(x: SaveOfferV2CustomLines) {
    // If line is a group and has invalid group path
    if (!x.path || !x.path.includes(x.name.replace('[ProductGroupId]', '').trim())) {
      return !x.path ? x.name.replace('[ProductGroupId]', '').trim() : x.path + '//' + x.name.replace('[ProductGroupId]', '').trim();
    }
    else {
      return x.path
    }
  }

  async joinedLinesToOfferLines(products: JoinedProduct[]) {
    let c: SaveOfferV2CustomLines[] = products?.filter(x => ['group', 'custom'].includes(x.type)).map(x => {
      return {
        id: x.id,
        name: x.type == 'group' && !x.description.startsWith('[ProductGroupId] ') ? `[ProductGroupId] ${x.description}` : x.description,
        costPrice: x.cost,
        salesPrice: x.type == 'group' ? x.totalSale : x.sale,
        totalCostPrice: x.totalCost,
        totalSalesPrice: x.totalSale,
        quantity: x.amount,
        profit: x.profit,
        discount: x.discount,
        sortOrder: x.sortOrder,
        priceGroupId: x.priceGroupId,
        packageId: x.unitId,
        path: x.path,
        showOnPdf: x.hideOnPdf
      }
    });

    let p: SaveOfferV2ProductLines[] = products?.filter(x => x.type == 'product').map(x => {
      return {
        id: x.id,
        productNumber: x.number,
        description: x.description,
        wholeSaler: x.wholesaler != null ? x.wholesaler.toString() : null,
        manufacturer: x.manufacturer,
        quantity: x.amount,
        costPrice: x.cost,
        listPrice: x.sale,
        profit: x.profit,
        discount: x.discount,
        image: x.image,
        sortOrder: x.sortOrder,
        companyProduct: x.companyProduct,
        packageId: x.unitId,
        path: x.path,
        accountId: !!+x.accountId ? +x.accountId : null,
        showOnPdf: x.hideOnPdf
      }
    });
    let s: SaveOfferV2SubcontractorLine[] = products?.filter(x => x.type == 'subcontractor').map(x => {
      return {
        id: x.id,
        name: x.description,
        costPrice: x.cost,
        salesPrice: x.sale,
        totalCostPrice: x.totalCost,
        totalSalesPrice: x.totalSale,
        quantity: x.amount,
        profit: x.profit,
        discount: x.discount,
        sortOrder: x.sortOrder,
        priceGroupId: x.priceGroupId,
        subContractorId: x.subcontractor.subContactorId,
        path: x.path,
        showOnPdf: x.hideOnPdf
      }
    })
    let t: SaveOfferV2CommentLines[] = products?.filter(x => x.type == 'comment').map(x => {
      return {
        id: x.id,
        comment: x.description,
        path: x.path,
        sortOrder: x.sortOrder,
        showOnPdf: x.hideOnPdf
      }
    });
    return {
      custom: c,
      products: p,
      subcontractor: s,
      comments: t
    }
  }

  async joinedLinesToPackageLines(products: JoinedProduct[]) {
    let c = products.filter(x => x.type == 'custom').map(x => {
      return {
        price: x.sale,
        id: x.id,
        name: x.description,
        costPrice: x.cost,
        salesPrice: x.sale,
        quantity: x.amount,
        priceGroupId: x.priceGroupId,
        profit: x.profit,
        discount: x.discount,
        sortOrder: x.sortOrder
      }
    });
    let p = products.filter(x => x.type == 'product').map(x => {
      return {
        productNumber: x.number,
        description: x.description,
        wholeSaler: x.wholesaler,
        manufacturer: x.manufacturer,
        quantity: x.amount,
        costPrice: x.cost,
        listPrice: x.sale,
        image: x.image,
        profit: x.profit,
        discount: x.discount,
        sortOrder: x.sortOrder,
        companyProduct: x.companyProduct
      }
    });
    let comments = products.filter(x => x.type == 'comment').map(x => {
      return {
        id: x.id,
        comment: x.description,
        sortOrder: x.sortOrder,
        path: x.path,
        showOnPdf: x.hideOnPdf
      }
    });
    return {
      custom: c,
      products: p,
      comments: comments
    }

  }

  clearPriceProductToJoined(product): JoinedProduct {
    let useProfit = +product.wholesaler > 99 ? false : true;
    let sale = +product.wholesaler > 99 ? product.listPrice : product.price * (1 + (product.profit / 100));
    console.log(product.path)
    return {
      id: null,
      type: 'product',
      description: product.description,
      cost: product.price,
      sale: sale,
      totalCost: product.price * product.quantity,
      totalSale: sale * product.quantity,
      number: product.number,
      amount: product.quantity,
      wholesaler: product.wholesaler,
      image: product.image,
      profit: useProfit ? product.profit : product.price != 0 && sale != 0 ? +(((sale - product.price) / product.price) * 100).toFixed(2) : 0,
      discount: 0,
      sortOrder: product.sortOrder,
      manufacturer: '',
      companyProduct: product.companyProduct,
      priceGroupId: null,
      path: product.path,
      accountId: product.accountId,
      hideOnPdf: false
    }
  }

  getClearPriceSalesPrice(number: string): Observable<any> {
    const headers: HttpHeaders = new HttpHeaders({ 'Authorization': localStorage.getItem('bearer') });
    return this.http.post(api.jubloApi + 'api/Website/KlarPris/GetKlarPrisSalesPrice', [number], { headers })
  }

  offerGetToOfferSave(o: GetOffer): SaveOfferV2 {
    return {
      attachment: null,
      establishedId: o.establishedId,
      costPrice: null,
      klarPrisAccount: o.klarPrisAccount,
      description: o.overview.description,
      responsibleId: o.responsible.key,
      skillId: o.skillsId,
      departmentId: o.departmentId,
      technicalDescription: o.technicalDescription,
      installationTimeInMinutes: Math.round(o.installationTimeInHours),
      totalPrice: +o.totalPrice,
      commentLines: o.commentLines,
      customLines: o.customLines,
      productLines: o.productLines,
      caseOfferStatusId: o.overview.status.key,
      offerMessage: o.offermessage,
      disclaimer: o.disclaimer,
      showProductLines: o.showProductLines,
      includeProductPage: o.includeProductPage,
      hideAmountOnPDF: o.hideAmountOnPDF,
      hideProductPricesOnPDF: o.hideProductPricesOnPDF,
      showHours: o.showHours,
      startDate: o.startDate,
      offerDate: o.offerDate,
      probability: o.probability,
      enterpriseTypeId: o.enterpriseTypeId,
      formOfProcurementId: o.formOfProcurementId,
      offerPdfId: o.offerPdfId,
      packageNumbers: [],
      pdfDesign: o.pdfDesign,
      priceGroupId: o.priceGroupId,
      stade: !!o.stade ? o.stade : 0,
      subContractorLine: o.subContractorLines,
      title: o.title,
      tradeGroupId: o.tradeGroupId
    }
  }

  saveOffer(offerId, offer: SaveOfferV2, sendMessage) {
    const headers: HttpHeaders = new HttpHeaders({ 'Authorization': localStorage.getItem('bearer') });
    return this.http.put(api.jubloApi + 'api/Website/Offer/UpdateOfferV2/' + offerId + '/' + sendMessage, offer, { headers })
  }


}

export class DocumentCreatorProductTableGrid {
  modules = [ClientSideRowModelModule, RowGroupingModule];
  getTreeData = (p) => { return !!p.path ? p.path.split('//') : null };
  components = { 'folderCellRenderer': this.getFolderCellRenderer() }
  rowsToDisplay: number = 0;
  packageText = '';
  commentEdit = {
    comment: '',
    id: null
  }
  columnOrder = ['image', 'wholesaler', 'description', 'number', 'cost', 'amount', 'profit', 'discount', 'sale', 'totalSale', 'coverage', 'deletion', 'sortOrder'];
  columnDefs = [
    { colId: 'image', field: 'image', flex: 1, editable: false, cellRenderer: this.imageRenderer, headerName: '' },
    { colId: 'wholesaler', flex: 1, editable: false, cellRenderer: this.wholesalerRenderer, headerName: '' },
    { colId: 'number', field: 'number', flex: 2, editable: false, cellRenderer: (params) => this.numberRenderer(params, this), headerName: 'Standard.ArticleNumber' },
    { colId: 'description', field: 'description', flex: 4, editable: true, rowDrag: true, cellStyle: { 'display': 'inline-block' }, headerName: 'Standard.Description', colSpan: (params) => { return !!params.data && params.data.type == 'comment' ? 8 : 1 } },
    { colId: 'cost', field: 'cost', flex: 2, editable: (params) => { return params.data.type == 'group' ? false : true }, cellRenderer: this.moneyRenderer, headerName: 'Standard.CostPriceShort', valueParser: this.numberParse, aggFunc: 'sum' },
    { colId: 'amount', field: 'amount', flex: 1, editable: (params) => { return params.data.type == 'group' ? false : true }, headerName: 'Standard.Quantity', valueParser: this.numberParse },
    { colId: 'profit', field: 'profit', flex: 1, editable: (params) => { return params.data.type == 'group' ? false : true }, headerName: 'Standard.Profit', valueParser: this.numberParse },
    { colId: 'discount', field: 'discount', flex: 1, editable: (params) => { return params.data.type == 'group' ? false : true }, headerName: 'Standard.Discount', valueParser: this.numberParse },
    { colId: 'sale', field: 'sale', flex: 2, editable: (params) => { return params.data.type == 'group' ? false : true }, cellRenderer: this.moneyRenderer, headerName: 'Standard.SalesPriceShort', valueParser: this.numberParse, aggFunc: 'sum' },
    { colId: 'totalSale', field: 'totalSale', flex: 2, editable: (params) => { return params.data.type == 'group' ? false : true }, cellRenderer: this.moneyRenderer, valueGetter: this.totalSaleGetter, headerName: 'Standard.Total', valueParser: this.numberParse, aggFunc: 'sum' },
    { colId: 'coverage', flex: 1, editable: false, cellRenderer: this.coverageRenderer, headerName: 'Standard.CVGE', aggFunc: 'sum', valueGetter: this.coverageGetter },
    { colId: 'deletion', flex: 1, editable: false, cellRenderer: this.trashRenderer, headerName: '' },
    { colId: 'sortOrder', field: 'sortOrder', hide: true, sortable: true, sort: { direction: 'asc' }, headerName: '' }
  ];
  default = {
    flex: 1,
    editable: true,
    suppressMenu: true,
    resizable: true,
    rowDrag: false,
    floatingFilterComponentParams: { suppressFilterButton: true },
    cellStyle: { 'display': 'flex', 'justify-content': 'flex-end', 'align-items': 'center!important', 'height': '100%' },
    suppressMovable: true,
    sortable: false
  };
  groupColDef = {
    headerName: '',
    flex: 1,
    cellClass: 'font-weight-bold',
    cellStyle: { 'display': 'flex', 'justify-content': 'center', 'align-items': 'center', 'height': '100%', 'color': 'black', 'font-size': '20px!important', 'font-weight': '700!important' },
    editable: true,
    cellRenderer: 'agGroupCellRenderer', cellRendererParams: {
      suppressCount: true,
      innerRenderer: 'folderCellRenderer'
    }
  }
  gridRowStyle = (params) => {

    if (!!params.data && params.data.type == 'group') {
      let a = [255 - (params.node.level * 15) - 25, 255 - (params.node.level * 15) - 25, 255 - (params.node.level * 15) - 25];
      // return params.node.level % 2 == 0 ? { background:'#d4d4d4', fontWeight:600 } : { background:'#e8e8e8', fontWeight:600 }
      return { background: 'rgb(' + a.toString() + ')', fontWeight: 600 }
    }
    else {
      let a = [255 - (params.node.level * 15), 255 - (params.node.level * 15), 255 - (params.node.level * 15),];
      return { background: 'rgb(' + a.toString() + ')' }
    }
  }
  coverageGetter(params) {
    if (!params.data) { return '' }
    return ((+params.data.sale - +params.data.cost) * +params.data.amount)
  }
  groupRender(params) {
    console.log(params)
    return params
  }
  imageRenderer(params) {
    return params.value != '' && params.value != null ? '<img style="max-height: 50px; max-width:50px;" src="' + params.value + '"\>' : '';
  };
  moneyRenderer(params) {
    return params.value != null ? new Intl.NumberFormat('da-DK', {
      style: 'currency',
      currency: 'DKK',
      minimumFractionDigits: 2,
      maximumFractionDigits: 2
    }).format(params.value) : 0
  };
  trashRenderer(params) {
    return '<span class="cursor-pointer text-center"><i class="fal fa-trash-alt" ></i></span>'
  };
  numberRenderer(params, obj) {
    if (!params.data) { return '' }
    if (!!params.data.unitId) {
      return params.data.priceGroupId == null ? '<div>' + params.value + '<span class="ml-2" title="' + obj.packageText + '"><i class="fas fa-box-open"></i></span></div>' : '<div><i class="far fa-clock"></i><span class="ml-2" title="' + obj.packageText + '"><i class="fas fa-box-open"></i></span></div>';
    }
    if (params.data.type == 'subcontractor') { return '<span title="' + '' + '"><i class="fas fa-user-hard-hat"></i></span>' }
    return params.data.priceGroupId == null ? params.value : '<i class="far fa-clock"></i>';
  };
  totalSaleGetter(params) {
    if (!params.data) { return '' }
    let d = params.data;
    return d.amount * d.sale
  };
  wholesalerRenderer(params) {
    if (!params.data || params.data.wholesaler == null || params.data.type == 'custom' || params.data.type == 'group') { return '' }
    if (+params.data.wholesaler < 100) { return '<img class="img-responsive wholesaler-images" src="../../../assets/wholesalerIcons/wholesaler_' + params.data.wholesaler + '_icon.png">' }
    if (+params.data.wholesaler > 100) { return '<img class="img-responsive wholesaler-images" src="https://mandrillstorage.blob.core.windows.net/attachment/wholesaler_' + params.data.wholesaler + '.png">' }
  };
  coverageRenderer(params) {
    if (!params.data) { return '' }
    if (params.data.type != 'group') {
      let inTheGreen = +params.data.sale > +params.data.cost ? 'text-success' : 'text-danger';
      let coverage = new Intl.NumberFormat('da-DK', {
        style: 'currency',
        currency: 'DKK',
        minimumFractionDigits: 2,
        maximumFractionDigits: 2
      }).format(params.value)
      return '<div class="' + inTheGreen + '">' + coverage + '</div>'
    }
    else {
      if (!params.node.aggData) return ''
      let inTheGreen = +params.node.aggData.sale > +params.node.aggData.cost ? 'text-success' : 'text-danger';
      let coverage = new Intl.NumberFormat('da-DK', {
        style: 'currency',
        currency: 'DKK',
        minimumFractionDigits: 2,
        maximumFractionDigits: 2
      }).format(params.value)
      return '<div class="' + inTheGreen + '">' + coverage + '</div>'
    }
  };
  numberParse(params) {
    return typeof (params.newValue) == 'string' ? +(params.newValue.replace(',', '.')) : params.newValue
  }
  getFolderCellRenderer() {
    function folderCellRenderer() { }
    folderCellRenderer.prototype.init = function (params) {
      var tempDiv = document.createElement('div');
      this.eGui = tempDiv.firstChild;
    }
    folderCellRenderer.prototype.getGui = function () {
      return this.eGui;
    }
    return folderCellRenderer
  }
  editingStep = 0;
  nextPrevious;
  suppressRowDrag: boolean = false;
  lastClickedCell: LastClickedCell;
  editComment(id, comment) {
    this.commentEdit.id = id;
    this.commentEdit.comment = comment;
  }
}

export class DocumentCreatorGridConversions {
  customLinesToJoinedProduct(c, input): JoinedProduct {
    return {
      id: c.id,
      description: c.name,
      number: '',
      cost: c.costPrice,
      sale: c.salesPrice,
      profit: c.profit,
      discount: c.discount,
      amount: c.quantity,
      image: '',
      sortOrder: c.sortOrder,
      totalCost: c.totalCostPrice,
      totalSale: c.totalSalesPrice,
      wholesaler: null,
      type: "custom",
      companyProduct: false,
      manufacturer: '',
      priceGroupId: c.priceGroupId,
      path: c.path,
      unitId: !!input && !!input.unit ? input.unit.packageId : null,
      hideOnPdf: c.showOnPdf
    }
  }
  async documentToGrid(d): Promise<Array<JoinedProduct>> {
    let products = [];
    for (let c of d.customLines) {
      if (c.name.startsWith('[ProductGroupId]')) {
        products.push(
          {
            id: c.id,
            description: c.name.replace('[ProductGroupId]', '').trim(),
            number: '',
            cost: c.costPrice,
            sale: c.salesPrice,
            profit: c.profit,
            discount: c.discount,
            amount: c.quantity,
            image: '',
            sortOrder: c.sortOrder,
            totalCost: c.totalCostPrice,
            totalSale: c.totalSalesPrice,
            wholesaler: '',
            type: 'group',
            companyProduct: false,
            manufacturer: '',
            priceGroupId: c.priceGroupId,
            unitId: c.packageId,
            path: !c.path ? c.name.replace('[ProductGroupId]', '').trim() : c.path,
            hideOnPdf: c.showOnPdf
          }
        )
      }
      else {
        products.push(
          {
            id: c.id,
            description: c.name,
            number: '',
            cost: c.costPrice,
            sale: c.salesPrice,
            profit: c.profit,
            discount: c.discount,
            amount: c.quantity,
            image: '',
            sortOrder: c.sortOrder,
            totalCost: c.totalCostPrice,
            totalSale: c.totalSalesPrice,
            wholesaler: '',
            type: 'custom',
            companyProduct: false,
            manufacturer: '',
            priceGroupId: c.priceGroupId,
            unitId: c.packageId,
            path: !c.path ? c.name : c.path + '//' + c.name,
            hideOnPdf: c.showOnPdf
          }
        )
      }
    }
    for (let p of d.productLines) {
      products.push(
        {
          id: p.productId,
          description: p.description,
          number: p.productNumber,
          cost: p.costPrice,
          sale: p.listPrice,
          profit: p.profit,
          discount: p.discount,
          amount: p.quantity,
          image: p.image,
          sortOrder: p.sortOrder,
          totalCost: p.totalCostPrice,
          totalSale: p.listPrice * p.quantity,
          wholesaler: p.wholeSaler,
          type: 'product',
          companyProduct: p.companyProduct,
          manufacturer: p.manufacturer,
          priceGroupId: null,
          unitId: p.packageId,
          path: !p.path ? p.description : p.path + '//' + p.description,
          hideOnPdf: p.showOnPdf
        }
      )
    }
    if (d.commentLines) {
      for (let c of d.commentLines) {
        products.push(
          {
            id: c.id,
            description: c.comment,
            number: null,
            cost: null,
            sale: null,
            profit: null,
            discount: null,
            amount: null,
            image: null,
            sortOrder: c.sortOrder,
            totalCost: null,
            totalSale: null,
            wholesaler: null,
            type: 'comment',
            companyProduct: null,
            manufacturer: null,
            priceGroupId: null,
            unitId: null,
            path: !c.path ? c.comment : c.path + '//' + c.comment,
            hideOnPdf: c.showOnPdf
          }
        )
      }
    }
    if (d.subContractorLines) {
      for (let s of d.subContractorLines) {
        products.push({
          id: s.id,
          description: s.name,
          number: '',
          cost: s.costPrice,
          sale: s.salesPrice,
          profit: s.profit,
          discount: s.discount,
          amount: s.quantity,
          image: '',
          sortOrder: s.sortOrder,
          totalCost: s.totalCostPrice,
          totalSale: s.totalSalesPrice,
          wholesaler: '',
          type: 'subcontractor',
          companyProduct: false,
          manufacturer: '',
          priceGroupId: s.priceGroupId,
          unitId: null,
          path: !s.path ? s.name : s.path + '//' + s.name,
          subcontractor: s.subContractor,
          hideOnPdf: s.showOnPdf
        }
        )
      }
    }

    return products.sort((a, b) => { return a.sortOrder < b.sortOrder ? -1 : 1 })
    return await this.gridGroupRows(products)
  }
  async gridGroupRows(p: Array<JoinedProduct>) {
    let start = Array.from(new Set(p.map(x => !!x.path ? x.path : '').filter(x => !!x)));
    p = await p.map(x => { return { ...x, path: !!x.path ? x.path + '//' + x.description : x.description } }) // add description to path to make a unique child i.e. id
    let paths = await this.getUniquePathspaths(start);
    console.log(paths)
    let pathsToSort = await this.getSortOrderByPath(paths, p);
    p = p.concat(
      await paths.map(x => {
        return {
          id: null,
          description: x.split('//').pop(),
          number: null,
          cost: null,
          sale: null,
          profit: null,
          discount: null,
          amount: null,
          image: null,
          sortOrder: pathsToSort[x],
          totalCost: null,
          totalSale: null,
          wholesaler: null,
          type: 'group',
          companyProduct: null,
          manufacturer: null,
          priceGroupId: null,
          unitId: null,
          path: x,
          hideOnPdf: x.hideOnPdf
        }

      })
    )
    // add group folders to p
    return await p.sort((a, b) => { return a.sortOrder < b.sortOrder ? -1 : 1 })
  }

  async getUniquePathspaths(paths: Array<string>) {
    // all Paths have at least one value, no null paths present
    let unique = [];
    await paths.forEach(x => {
      let a = x.split('//');
      for (var i = 0; i < a.length; i++) {
        if (!unique.includes(a.slice(0, i + 1).join('//'))) { unique.push(a.slice(0, i + 1).join('//')) }
      }
    })
    return unique
  }

  async getSortOrderByPath(paths: Array<string>, p: Array<JoinedProduct>) {
    let obj = {};
    for (var i = 0; i < paths.length; i++) {
      let products = p.filter(x => x.path.split('//').slice(0, -1).join('//') == paths[i] && x.sortOrder != null).map(x => x.sortOrder);
      obj[paths[i]] = products.length > 0 ? Math.min(...products) - 1 : p.length + i;
    }
    return obj
  }

  mapProductGroups(products: Array<JoinedProduct>) {
    return products.filter(x => x.type == 'group').map(x => {
      return {
        path: x.path,
        description: x.description.replace('[ProductGroupId]', '').trim()
      }
    })
  }
  countGroupsInJoinedProducts(products: Array<JoinedProduct>) {
    return products.reduce((total, curr) => { return curr.type == 'group' ? total + 1 : total }, 0)
  }
  async gridToDocument(products) {
    let c: Array<customLines> = [];
    let p: Array<productLines> = [];
    let s: Array<SubcontractorLine> = []
    let t: Array<CommentLine> = [];
    for (let x of products) {
      switch (x.type) {
        case ('product'): {
          p.push(
            {
              productId: x.id,
              productNumber: x.number,
              description: x.description,
              wholeSaler: x.wholesaler != null ? x.wholesaler.toString() : null,
              manufacturer: x.manufacturer,
              quantity: x.amount,
              costPrice: x.cost,
              listPrice: x.sale,
              profit: x.profit,
              discount: x.discount,
              image: x.image,
              sortOrder: x.sortOrder,
              //totalCostPrice: x.totalCost,
              companyProduct: x.companyProduct,
              packageId: x.unitId,
              path: !!x.path && !!x.path.split('//').slice(0, -1).join('//') ? x.path.split('//').slice(0, -1).join('//') : null
            }

          )
            ; break
        }
        case ('custom'): {
          c.push(
            {
              id: x.id,
              name: x.description,
              costPrice: x.cost,
              salesPrice: x.sale,
              totalCostPrice: x.totalCost,
              totalSalesPrice: x.totalSale,
              quantity: x.amount,
              profit: x.profit,
              discount: x.discount,
              sortOrder: x.sortOrder,
              priceGroupId: x.priceGroupId,
              packageId: x.unitId,
              path: !!x.path && !!x.path.split('//').slice(0, -1).join('//') ? x.path.split('//').slice(0, -1).join('//') : null
            }
          )
            ; break
        }
        case ('subcontractor'): {
          s.push(
            {
              id: x.id,
              name: x.description,
              costPrice: x.cost,
              salesPrice: x.sale,
              totalCostPrice: x.totalCost,
              totalSalesPrice: x.totalSale,
              quantity: x.amount,
              profit: x.profit,
              discount: x.discount,
              sortOrder: x.sortOrder,
              priceGroupId: x.priceGroupId,
              subcontractor: x.subcontractor,
              path: !!x.path && !!x.path.split('//').slice(0, -1).join('//') ? x.path.split('//').slice(0, -1).join('//') : null
            }
          );
          break
        }
        case ('group'): {
          c.push(
            {
              id: x.id,
              name: '[ProductGroupId] ' + x.description,
              costPrice: x.cost,
              salesPrice: x.sale,
              totalCostPrice: x.totalCost,
              totalSalesPrice: x.totalSale,
              quantity: x.amount,
              profit: x.profit,
              discount: x.discount,
              sortOrder: x.sortOrder,
              priceGroupId: null,
              packageId: null,
              path: x.path
            });
          break
        }
        case ('comment'): {
          t.push(
            {
              id: x.id,
              comment: x.description,
              path: !!x.path && !!x.path.split('//').slice(0, -1).join('//') ? x.path.split('//').slice(0, -1).join('//') : null,
              sortOrder: x.sortOrder
            }
          )
        }
      }
    }
    return {
      custom: c,
      products: p,
      subcontractor: s,
      comments: t
    }
  }
  sumByTableContent(products: Array<JoinedProduct>) {
    let cost = +products.filter(x => !['group', 'comment'].includes(x.type) && !x.priceGroupId).reduce((sum, x) => {
      return sum + +x.totalCost.toFixed(2)
    }, 0).toFixed(2);
    let hourCost = +products.filter(x => !['group', 'comment'].includes(x.type) && !!x.priceGroupId).reduce((sum, x) => {
      return sum + +x.totalCost.toFixed(2)
    }, 0).toFixed(2);
    let hourCoverage = +products.reduce((sum, x) => { return sum + (x.priceGroupId != null ? (x.sale - x.cost) * x.amount : 0) }, 0).toFixed(2);
    let materialCoverage = +products.filter(x => !['group', 'comment'].includes(x.type)).reduce((sum, x) => { return sum + (x.priceGroupId == null ? (x.sale - x.cost) * x.amount : 0) }, 0).toFixed(2);
    let sales = +products.reduce((sum, x) => { return sum + (+x.sale * x.amount) }, 0);
    let hours = +products.reduce((sum, x) => { return x.priceGroupId != null ? sum + x.amount : sum }, 0);
    let contributionMargin = sales - (cost + hourCost);
    return {
      cost: +cost,
      hourCost: +hourCost,
      totalCost: +cost + +hourCost,
      sale: sales,
      salePlusVat: +sales * 1.25,
      hours: hours,
      contributionMargin: +(contributionMargin).toFixed(2),
      contributionRatio: +(contributionMargin / sales * 100).toFixed(1),
      coveragePerHour: +(contributionMargin / hours).toFixed(2),
      hourCoverage: hourCoverage,
      materialCoverage: materialCoverage
    }
  }

  async getCoverages(cost: number, sales: number, hours: number, totals: DocumentTotals): Promise<DocumentTotals> {
    let contributionMargin = sales - cost;
    return {
      cost: cost,
      hourCost: totals.hourCost,
      totalCost: totals.totalCost,
      sale: sales,
      salePlusVat: +sales * 1.25,
      hours: hours,
      contributionMargin: +(contributionMargin).toFixed(2),
      contributionRatio: +(contributionMargin / sales * 100).toFixed(1),
      coveragePerHour: +(contributionMargin / hours).toFixed(2),
      hourCoverage: totals.hourCoverage,
      materialCoverage: totals.materialCoverage
    }
  }
  async changeTotalByPart(what, totals: DocumentTotals): Promise<DocumentTotals> {
    switch (what) {
      case ('TotalPriceExVat'): {
        let margin = totals.sale - totals.totalCost;
        return {
          cost: totals.cost,
          hourCost: totals.hourCost,
          totalCost: totals.totalCost,
          sale: totals.sale,
          salePlusVat: totals.sale * 1.25,
          hours: totals.hours,
          contributionMargin: +margin.toFixed(2),
          contributionRatio: +(margin / totals.sale * 100).toFixed(1),
          coveragePerHour: +(margin / totals.hours).toFixed(2),
          hourCoverage: totals.hourCoverage,
          materialCoverage: totals.materialCoverage
        }
      }
      case ('TotalPrice'): {
        let margin = (totals.salePlusVat * 0.8) - totals.totalCost;
        return {
          cost: totals.cost,
          hourCost: totals.hourCost,
          totalCost: totals.totalCost,
          sale: totals.salePlusVat * 0.8,
          salePlusVat: totals.salePlusVat,
          hours: totals.hours,
          contributionMargin: +margin.toFixed(2),
          contributionRatio: +(margin / (totals.salePlusVat * 0.8) * 100).toFixed(1),
          coveragePerHour: +(margin / totals.hours).toFixed(2),
          hourCoverage: totals.hourCoverage,
          materialCoverage: totals.materialCoverage
        }
      }
      case ('ContributionRatio'): {
        let newSale = (totals.totalCost / (100 - totals.contributionRatio)) * 100;
        let margin = newSale - totals.totalCost;
        return {
          cost: totals.cost,
          hourCost: totals.hourCost,
          totalCost: totals.totalCost,
          sale: +newSale.toFixed(2),
          salePlusVat: +(newSale * 1.25).toFixed(2),
          hours: totals.hours,
          contributionMargin: +(margin).toFixed(2),
          contributionRatio: +(totals.contributionRatio).toFixed(1),
          coveragePerHour: +(margin / totals.hours).toFixed(2),
          hourCoverage: totals.hourCoverage,
          materialCoverage: totals.materialCoverage
        }
      }
      default: {
        return totals
      }
    }
  }
  clearPriceProductToJoined(product, profit, sortOrder): JoinedProduct {
    let useProfit = +product.wholesaler > 99 ? false : true;
    let sale = +product.wholesaler > 99 ? product.listPrice : product.price * (1 + (profit / 100));
    return {
      id: null,
      type: 'product',
      description: product.description,
      cost: product.price,
      sale: sale,
      totalCost: product.price * product.quantity,
      totalSale: sale * product.quantity,
      number: product.number,
      amount: product.quantity,
      wholesaler: product.wholesaler,
      image: product.image,
      profit: useProfit ? profit : product.price != 0 && sale != 0 ? +(((sale - product.price) / product.price) * 100).toFixed(2) : 0,
      discount: 0,
      sortOrder: sortOrder,
      manufacturer: '',
      companyProduct: product.companyProduct,
      priceGroupId: null,
      hideOnPdf: false
    }
  }

  commentLineToJoined(comment, id, sortOrder, path): JoinedProduct {
    console.log('creating comment line', path)
    return {
      id: id,
      description: comment,
      companyProduct: null,
      number: null,
      cost: null,
      sale: null,
      profit: null,
      discount: null,
      amount: null,
      image: null,
      sortOrder: sortOrder,
      totalCost: null,
      totalSale: null,
      wholesaler: null,
      manufacturer: null,
      priceGroupId: null,
      subcontractor: null,
      unitId: null,
      path: !!path && path != 'null' ? path + '//' + comment : comment,
      type: 'comment',
      hideOnPdf: false
    }
  }

}

export class DocumentTotals {
  cost: number;
  hourCost: number;
  totalCost: number;
  sale: number;
  salePlusVat: number;
  hours: number;
  contributionMargin: number;
  contributionRatio: number;
  coveragePerHour: number;
  hourCoverage: number;
  materialCoverage: number;
}

interface LastClickedCell {
  col: string;
  row: number;
}

export class JoinedProduct {
  id: string;
  description: string = '';
  companyProduct: boolean = false;
  number: string;
  cost: number = 0;
  sale: number = 0;
  profit: number = 0;
  discount: number = 0;
  amount: number = 1;
  image: string;
  sortOrder: number = 0;
  totalCost: number = 0;
  totalSale: number = 0;
  wholesaler: string;
  manufacturer: string;
  priceGroupId: string;
  subcontractor?: SubcontractorLineSubContractor;
  unitId?: string;
  path?: string;
  accountId?: string;
  type: 'custom' | 'product' | 'group' | 'subcontractor' | 'comment' | string;
  hideOnPdf: boolean;
}

export class Product extends JoinedProduct {
  isOpen: boolean = false;
  children: Product[] = [];
  level: number = 0;
  groupUnits?: string[];
}

export class SubcontractorLine {
  id: string;
  name: string;
  costPrice: number;
  salesPrice: number;
  quantity: number;
  totalCostPrice: number;
  totalSalesPrice: number;
  profit: number;
  discount: number;
  sortOrder: number;
  priceGroupId: string;
  path: string;
  subcontractor: SubcontractorLineSubContractor;
}

export class SubcontractorLineSubContractor {
  subContactorId: string;
  name: string;
  logo: string;
}

export class NewSubcontractorLine {
  line = new JoinedProduct();
  page: 'choosePartner' | 'completeLine' = 'choosePartner';
  reset() {
    this.line = {
      id: null,
      companyProduct: false,
      cost: 0,
      description: '',
      discount: 0,
      image: null,
      manufacturer: null,
      number: null,
      path: '',
      priceGroupId: null,
      profit: 0,
      sale: 0,
      amount: 1,
      sortOrder: 0,
      totalCost: 0,
      totalSale: 0,
      type: 'subcontractor',
      subcontractor: null,
      unitId: null,
      wholesaler: null,
      hideOnPdf: false
    }

  }
  calcPrice(type) {
    switch (type) {
      case ('sale'): {
        this.line.profit = ((+this.line.sale - this.line.cost) / this.line.cost) * 100;
        break
      }
      default: {
        this.line.sale = this.line.cost * (1 + (this.line.profit / 100));
        break
      }
    }
  }

  totalCostPrice() {
    return this.line.cost * this.line.amount
  }
  totalSalesPrice() {
    return this.line.sale * this.line.amount
  }
}

export class CommentLine {
  id: string;
  comment: string = '';
  path: string;
  sortOrder: number;
}

export interface SaveOfferV2 {
  attachment: string[];
  caseOfferStatusId: string;
  commentLines: SaveOfferV2CommentLines[];
  costPrice: number;
  customLines: SaveOfferV2CustomLines[];
  departmentId: string;
  description: string;
  disclaimer: string;
  enterpriseTypeId: string;
  establishedId: string;
  formOfProcurementId: string;
  hideProductPricesOnPDF: boolean;
  hideAmountOnPDF: boolean;
  includeProductPage: boolean;
  installationTimeInMinutes: number;
  klarPrisAccount: string;
  offerDate: string;
  offerMessage: string;
  offerPdfId: string;
  packageNumbers: string[];
  pdfDesign: string;
  priceGroupId: string;
  probability: number;
  productLines: SaveOfferV2ProductLines[];
  responsibleId: string;
  showHours: boolean;
  showProductLines: boolean;
  skillId: string;
  stade: number // ??? should be string
  startDate: string;
  subContractorLine: SaveOfferV2SubcontractorLine[];
  technicalDescription: string;
  title: string;
  totalPrice: number;
  tradeGroupId: string;
}


export interface SaveOfferV2CommentLines {
  comment: string;
  id: string;
  path: string;
  sortOrder: number;
}
export interface SaveOfferV2CustomLines {
  costPrice: number;
  discount: number;
  id: string;
  name: string;
  packageId: string;
  path: string;
  priceGroupId: string;
  profit: number;
  quantity: number;
  salesPrice: number;
  sortOrder: number;
}

export interface SaveOfferV2ProductLines {
  accountId: number; // ??? should be string
  companyProduct: boolean;
  costPrice: number;
  description: string;
  discount: number;
  id: string;
  image: string;
  listPrice: number;
  manufacturer: string;
  packageId: string;
  path: string;
  productNumber: string;
  profit: number;
  quantity: number;
  sortOrder: number;
  wholeSaler: string;
}

export interface SaveOfferV2SubcontractorLine {
  costPrice: number;
  discount: number;
  id: string;
  name: string;
  path: string;
  priceGroupId: string;
  profit: number;
  quantity: number;
  salesPrice: number;
  sortOrder: number;
  subContractorId: string;
}

export class GetOffer {
  acceptanceDate: string;
  caseId: string;
  commentLines: SaveOfferV2CommentLines[];
  companyId: string;
  consecutivelyOfferNumber: number;
  customerId: string;
  customLines: SaveOfferV2CustomLines[];
  departmentId: string;
  disclaimer: string;
  enterpriseTypeId: string;
  establishedId: string;
  externalPdfId: string;
  formOfProcurementId: string;
  hideAmountOnPDF: boolean;
  hideProductPricesOnPDF: boolean;
  hoursCostPrice: number;
  hoursSalesPrice: number;
  image: string;
  includeProductPage: boolean;
  installationTimeInHours: number;
  klarPrisAccount: string;
  offerDate: string;
  offerId: string;
  offermessage: string;
  offerNumber: number;
  offerPdfId: string;
  offerTypeId: string;
  overview: any;
  pdfDesign: string;
  priceGroupId: string;
  probability: number;
  productLines: SaveOfferV2ProductLines[];
  profitMargin: number;
  responsible: GetOfferResponsible;
  sentAt: string;
  showHours: boolean;
  showProductLines: boolean;
  skillsId: string;
  stade: number;
  startDate: string;
  startingFee: number;
  subContractorLines: SaveOfferV2SubcontractorLine[];
  technicalDescription: string;
  title: string;
  totalPrice: number;
  tradeGroupId: string;
  variationOrderNumber: number;
}

interface GetOfferResponsible {
  email: string
  key: string;
  phone: string;
  name: string;
  title: string;
}